export default __webpack_public_path__ + "fail.c4de377369e37653.svg";